module.exports = __webpack_public_path__ + "static/media/familia.0ab09290.png";